<template lang="pug">
    div.image-editor-crop-control
        image-cropper(:src='image' alt='Source Image' :aspect-ratio='aspectRatio' ref='cropper')

        p.image-editor-crop-control__label Choose Crop Size
        radio-select-field(v-model='aspectRatio' :options='cropSizes' mode='compact')
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
    name: 'image-editor-crop-control',

    components: {
        'image-cropper': VueCropper,
    },

    props: {
        image: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            aspectRatio: null,
        }
    },

    computed: {
        cropSizes() {
            return [
                { label: '2:2', value: 2 / 2 },
                { label: '3:2', value: 3 / 2 },
                { label: '4:3', value: 4 / 3 },
                { label: '5:4', value: 5 / 4 },
            ]
        },
    },

    watch: {
        image: {
            handler() {
                this.reset()
            },
            immediate: true,
        },
        aspectRatio(value) {
            this.$refs.cropper.setAspectRatio(value)
        },
    },

    methods: {
        reset() {
            this.aspectRatio = 4 / 3
            if (this.$refs.cropper) {
                this.$refs.cropper.replace(this.image)
            }
        },
        crop() {
            return this.$refs.cropper.getCroppedCanvas().toDataURL()
        },

        getModifiedImage() {
            return this.crop()
        },
    },
}
</script>
